import React, { useEffect, useState } from 'react'
import { useForm, usePage } from '@inertiajs/inertia-react'
import Layout from '../../Shared/Layout/LayoutAdmin'
import Breadcrumbs from '../../Shared/Components/Breadcrumbs'
import PaginationList from '../../Shared/Components/PaginationList'
import AlertDismissible from '../../Shared/Components/AlertDismissible'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import axios from 'axios'
import { SIA_NAVY } from '../../constants/siaTheme'

function formatDate(val) {
    if (!val) return '—'
    const d = String(val).slice(0, 10)
    const [y, m, day] = d.split('-')
    return `${day}/${m}/${y}`
}

function HistoryModal({ show, onHide, logs, policyNumber }) {
    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Registro de bitácora de la póliza {policyNumber || ''}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {(!logs || logs.length === 0) ? (
                    <p className="text-muted mb-0">Sin registros de seguimiento.</p>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-row-bordered table-row-gray-300 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted text-uppercase fs-7 bg-light">
                                    <th className="ps-4">Póliza</th>
                                    <th>Contactó</th>
                                    <th>Fecha de contacto</th>
                                    <th>Tipo de contacto</th>
                                    <th>¿Respondió?</th>
                                    <th className="pe-4">Observaciones</th>
                                </tr>
                            </thead>
                            <tbody className="fs-7">
                                {logs.map((log) => (
                                    <tr key={log.id}>
                                        <td className="ps-4">{log.policy}</td>
                                        <td>{log.contacted_by}</td>
                                        <td>{formatDate(log.contact_date)}</td>
                                        <td>{log.contact_type}</td>
                                        <td>{log.responded}</td>
                                        <td className="pe-4" style={{ whiteSpace: 'pre-wrap' }}>{log.observations}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={onHide}>Cerrar</Button>
            </Modal.Footer>
        </Modal>
    )
}

function FollowUpModal({
    show,
    onHide,
    policy,
    contactTypes,
    defaultDate,
}) {
    const form = useForm({
        contact_date: defaultDate || '',
        cobranza_contact_type_id: '',
        responded: '',
        observations: '',
    })

    useEffect(() => {
        if (show && policy) {
            form.setData({
                contact_date: defaultDate || '',
                cobranza_contact_type_id: '',
                responded: '',
                observations: '',
            })
            form.clearErrors()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show, policy?.id, defaultDate])

    const submit = (e) => {
        e.preventDefault()
        if (!policy) return
        form.post(route('cobranza.follow-up.store', policy.id), {
            preserveScroll: true,
            onSuccess: () => onHide(),
        })
    }

    return (
        <Modal show={show} onHide={() => !form.processing && onHide()} size="lg" centered backdrop="static">
            <Form onSubmit={submit}>
                <Modal.Header closeButton={!form.processing}>
                    <Modal.Title>Datos necesarios para el registro</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {policy && (
                        <p className="text-muted fs-7 mb-6">
                            Póliza <span className="fw-semibold text-gray-800">{policy.policy}</span>
                            {policy.insured_name ? ` — ${policy.insured_name}` : ''}
                        </p>
                    )}
                    <Row className="g-4">
                        <Col md={6}>
                            <Form.Group className="mb-4">
                                <Form.Label className="fw-bold">Fecha <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={form.data.contact_date}
                                    onChange={(e) => form.setData('contact_date', e.target.value)}
                                    isInvalid={!!form.errors.contact_date}
                                    disabled={form.processing}
                                />
                                <Form.Control.Feedback type="invalid">{form.errors.contact_date}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-4">
                                <Form.Label className="fw-bold">Tipo de contacto <span className="text-danger">*</span></Form.Label>
                                <Form.Select
                                    value={form.data.cobranza_contact_type_id}
                                    onChange={(e) => form.setData('cobranza_contact_type_id', e.target.value)}
                                    isInvalid={!!form.errors.cobranza_contact_type_id}
                                    disabled={form.processing}
                                >
                                    <option value="">Seleccione una opción</option>
                                    {(contactTypes || []).map((t) => (
                                        <option key={t.id} value={t.id}>{t.name}</option>
                                    ))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">{form.errors.cobranza_contact_type_id}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-0">
                                <Form.Label className="fw-bold">¿Le respondió? <span className="text-danger">*</span></Form.Label>
                                <Form.Select
                                    value={form.data.responded}
                                    onChange={(e) => form.setData('responded', e.target.value)}
                                    isInvalid={!!form.errors.responded}
                                    disabled={form.processing}
                                >
                                    <option value="">Seleccione una opción</option>
                                    <option value="1">Sí</option>
                                    <option value="0">No</option>
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">{form.errors.responded}</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-0 h-100 d-flex flex-column">
                                <Form.Label className="fw-bold">Observaciones <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={8}
                                    className="flex-grow-1"
                                    value={form.data.observations}
                                    onChange={(e) => form.setData('observations', e.target.value)}
                                    isInvalid={!!form.errors.observations}
                                    disabled={form.processing}
                                />
                                <Form.Control.Feedback type="invalid">{form.errors.observations}</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={onHide} disabled={form.processing}>
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        disabled={form.processing}
                        style={{ backgroundColor: SIA_NAVY, borderColor: SIA_NAVY }}
                    >
                        {form.processing ? 'Guardando…' : 'Registrar'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

const CobranzaRecords = ({
    entries,
    filters,
    offices,
    advisers,
    statuses,
    contactTypes = [],
    defaultContactDate,
    canExport,
    canCreateLog,
    canViewLog,
}) => {
    const { flash } = usePage().props
    const filterForm = useForm({
        show: filters.show || 'all',
        office_id: filters.office_id || '',
        adviser_id: filters.adviser_id || '',
        cobranza_status_id: filters.cobranza_status_id || '',
        search: filters.search || '',
    })
    const [history, setHistory] = useState({ show: false, logs: [], policy: '' })
    const [followUp, setFollowUp] = useState({ show: false, policy: null })

    const submitFilters = (e) => {
        e.preventDefault()
        filterForm.get(route('cobranza.records.index'), { preserveState: true })
    }

    const openHistory = async (row) => {
        const { data } = await axios.get(route('cobranza.follow-up.history', row.id))
        setHistory({ show: true, logs: data.logs || [], policy: row.policy })
    }

    const rows = entries.data || []

    return (
        <Row>
            {flash?.success && <AlertDismissible message={flash.success} type="success" />}
            <span className="pb-7 pt-7">
                <Breadcrumbs currentPath="admin/cobranza/registros" />
            </span>

            <div
                className="rounded-2 mb-8 py-4 px-4 text-center text-white text-uppercase fw-bold fs-4"
                style={{ backgroundColor: SIA_NAVY, letterSpacing: '0.04em' }}
            >
                Panel de Cobranza
            </div>

            <div className="card card-flush shadow-sm mb-8">
                <div className="card-body py-8 px-6">
                    <Form onSubmit={submitFilters} className="row g-4 align-items-end">
                        <Col md={3}>
                            <Form.Label className="fw-bold fs-7">Mostrar</Form.Label>
                            <Form.Select
                                className="form-select-solid"
                                value={filterForm.data.show}
                                onChange={(e) => filterForm.setData('show', e.target.value)}
                            >
                                <option value="all">TODOS LOS REGISTROS</option>
                                <option value="sin_cobro">PÓLIZAS SIN COBRO</option>
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <Form.Label className="fw-bold fs-7">Oficina</Form.Label>
                            <Form.Select
                                className="form-select-solid"
                                value={filterForm.data.office_id}
                                onChange={(e) => filterForm.setData('office_id', e.target.value)}
                            >
                                <option value="">Seleccione una opción</option>
                                {offices.map((o) => <option key={o.id} value={o.id}>{o.nombre}</option>)}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <Form.Label className="fw-bold fs-7">Asesor</Form.Label>
                            <Form.Select
                                className="form-select-solid"
                                value={filterForm.data.adviser_id}
                                onChange={(e) => filterForm.setData('adviser_id', e.target.value)}
                            >
                                <option value="">Seleccione una opción</option>
                                {advisers.map((a) => <option key={a.id} value={a.id}>{a.display_name}</option>)}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <Form.Label className="fw-bold fs-7">Status</Form.Label>
                            <Form.Select
                                className="form-select-solid"
                                value={filterForm.data.cobranza_status_id}
                                onChange={(e) => filterForm.setData('cobranza_status_id', e.target.value)}
                            >
                                <option value="">Seleccione una opción</option>
                                {statuses.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
                            </Form.Select>
                        </Col>
                        <Col md={12} className="text-center pt-2">
                            <Button
                                type="submit"
                                disabled={filterForm.processing}
                                style={{ backgroundColor: SIA_NAVY, borderColor: SIA_NAVY }}
                            >
                                Mostrar Resultados
                            </Button>
                        </Col>
                    </Form>
                </div>
            </div>

            <div className="card card-flush shadow-sm">
                <div className="card-header border-0 pt-6 flex-wrap gap-3">
                    <h3 className="card-title fw-bold text-gray-800">Resultados</h3>
                    <div className="card-toolbar d-flex flex-wrap align-items-center gap-3">
                        {canExport && (
                            <a className="btn btn-sm btn-light-primary" href={route('cobranza.records.export', filterForm.data)}>
                                <i className="bi bi-file-earmark-excel me-1" />
                                Excel
                            </a>
                        )}
                        <Form onSubmit={submitFilters} className="d-flex gap-2">
                            <Form.Control
                                size="sm"
                                className="form-control-solid"
                                placeholder="Buscar…"
                                value={filterForm.data.search}
                                onChange={(e) => filterForm.setData('search', e.target.value)}
                                style={{ minWidth: '180px' }}
                            />
                            <Button type="submit" size="sm" variant="light">Buscar</Button>
                        </Form>
                    </div>
                </div>
                <div className="card-body pt-0">
                    <div className="table-responsive">
                        <table className="table table-row-bordered table-row-gray-300 align-middle gs-0 gy-4">
                            <thead>
                                <tr className="fw-bold text-muted text-uppercase fs-7 bg-light">
                                    <th className="min-w-100px ps-4 rounded-start">Oficina</th>
                                    <th className="min-w-120px">Asesor</th>
                                    <th className="min-w-160px">Asegurado</th>
                                    <th className="min-w-100px">Teléfono</th>
                                    <th className="min-w-110px">Póliza</th>
                                    <th className="min-w-100px">Vigencia</th>
                                    <th className="min-w-100px">Prima Mensual</th>
                                    <th className="min-w-120px">Pagada hasta</th>
                                    <th className="min-w-110px">Método de pago</th>
                                    <th className="min-w-130px">Próxima fecha de pago</th>
                                    <th className="min-w-100px">Días vencidos</th>
                                    <th className="min-w-100px">Status</th>
                                    <th className="min-w-100px text-end pe-4 rounded-end">Acciones</th>
                                </tr>
                            </thead>
                            <tbody className="fs-7">
                                {rows.length === 0 ? (
                                    <tr>
                                        <td colSpan={13} className="text-center text-muted py-10">
                                            No hay registros para los filtros seleccionados.
                                        </td>
                                    </tr>
                                ) : (
                                    rows.map((row) => (
                                        <tr key={row.id}>
                                            <td className="ps-4 text-gray-800">{row.office_name || '—'}</td>
                                            <td className="text-gray-800">{row.adviser_name || '—'}</td>
                                            <td className="fw-semibold text-gray-800">{row.insured_name || '—'}</td>
                                            <td className="text-gray-700">{row.phone || '—'}</td>
                                            <td className="text-gray-800">{row.policy}</td>
                                            <td>{formatDate(row.validity)}</td>
                                            <td>{row.monthly_premium ?? '—'}</td>
                                            <td>
                                                {row.overdue_level === 'none' ? (
                                                    <span className="badge badge-light-danger">SIN RECIBOS PAGADOS AÚN</span>
                                                ) : formatDate(row.paid_up)}
                                            </td>
                                            <td>{row.payment_method || '—'}</td>
                                            <td>{formatDate(row.next_payment_date)}</td>
                                            <td>
                                                {row.overdue_level === 'none' ? '—' : (
                                                    <span
                                                        className={
                                                            row.overdue_level === 'red'
                                                                ? 'badge badge-light-danger'
                                                                : row.overdue_level === 'yellow'
                                                                    ? 'badge badge-light-warning'
                                                                    : 'text-gray-800'
                                                        }
                                                    >
                                                        {row.days_overdue}
                                                    </span>
                                                )}
                                            </td>
                                            <td>{row.status_name || '—'}</td>
                                            <td className="text-end pe-4">
                                                <div className="d-flex justify-content-end gap-1">
                                                    <a
                                                        className="btn btn-sm btn-icon btn-light-primary"
                                                        href={route('insurance.list', { poliza: row.policy })}
                                                        title="Editar póliza"
                                                    >
                                                        <i className="bi bi-pencil" />
                                                    </a>
                                                    {canCreateLog && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-icon btn-light-primary"
                                                            title="Agregar seguimiento"
                                                            onClick={() => setFollowUp({ show: true, policy: row })}
                                                        >
                                                            <i className="bi bi-plus-lg" />
                                                        </button>
                                                    )}
                                                    {canViewLog && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-icon btn-light-primary"
                                                            title="Ver historial"
                                                            onClick={() => openHistory(row)}
                                                        >
                                                            <i className="bi bi-list-ul" />
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="d-flex justify-content-center py-6">
                        <PaginationList links={entries.links} filters={filterForm.data} />
                    </div>
                </div>
            </div>

            <HistoryModal
                show={history.show}
                onHide={() => setHistory({ show: false, logs: [], policy: '' })}
                logs={history.logs}
                policyNumber={history.policy}
            />

            <FollowUpModal
                show={followUp.show}
                onHide={() => setFollowUp({ show: false, policy: null })}
                policy={followUp.policy}
                contactTypes={contactTypes}
                defaultDate={defaultContactDate}
            />
        </Row>
    )
}

CobranzaRecords.layout = (page) => <Layout title="Cobranza">{page}</Layout>

export default CobranzaRecords
export { HistoryModal, formatDate }
